import React, { useState } from "react";
import * as Yup from "yup";
import classNames from "classnames";
import { useUserContext } from "store/contexts/userContext";
import AttachmentSelection from "components/AttachmentSelection/AttachmentSelection";
import AttachmentPreview from "components/AttachmentPreview/AttachmentPreview";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import ButtonWithProgress from "components/ButtonWithProgress";
import { useFormik } from "formik";
import WaterCoolerReaction from "../WaterCoolerReaction";
import { useMoodsContext } from "store/contexts/moodsContext";
import { sendMessage } from "services/TwilioService";
import { useWaterCoolerContext } from "store/contexts/waterCoolerContext";
import { scrollToBottomOfWaterCooler } from "utils/helpers";

var styles = {
  root: {
    display: "flex",
  },
  content: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  inputField: {
    width: "100%",
    display: "flex",
    borderRadius: "40px",
    outline: "none",
    padding: "10px 15px 0",
    margin: "5px 0 0",
    maxHeight: "100px",
  },
  allIcons: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
};

export default () => {
  const classes = styles;
  const { user } = useUserContext();
  const [uploadProgress, setUploadProgress] = useState(0);
  const { channelInformation } = useWaterCoolerContext();
  const [allemoji] = useState([
    {
      id: 7,
      emoji: "🤩",
      name: "great",
    },
    {
      id: 8,
      emoji: "👏",
      name: "congratulations",
    },
    {
      id: 9,
      emoji: "😕",
      name: "Unsure",
    },
    {
      id: 10,
      emoji: "😳",
      name: "Confused",
    },
    {
      id: 11,
      emoji: "😟",
      name: "Sad",
    },
    {
      id: 12,
      emoji: "👍",
      name: "Like",
    },
  ]);
  const { buzzes } = useMoodsContext();

  const formik = useFormik({
    initialValues: {
      comment: "",
      attachment: null,
    },
    validationSchema: Yup.object().shape(
      {
        comment: Yup.string().when(["attachment"], {
          is: (attachment) => {
            return !attachment;
          },
          then: Yup.string()
            .trim()
            .required(
              "You cannot send message with space only, either send a message or attach an image."
            ),
        }),
        attachment: Yup.mixed().when(["comment"], {
          is: (comment) => {
            return !comment;
          },
          then: Yup.mixed().required("Attachment is required."),
        }),
      },
      ["attachment", "comment"]
    ),
    onSubmit: async (values) => {
      try {
        var copyUser = {
          ...user,
          full_name: `${user.first_name} ${user.last_name}`,
        };

        await sendMessage(values, channelInformation, copyUser);

        setUploadProgress(100);
        formik.resetForm();
        setUploadProgress(0);
        scrollToBottomOfWaterCooler();
      } catch (e) {
        console.log(e);
      }
    },
  });

  const selectedBuzzData = (reactionId) => {
    let selectedbuzz = allemoji.find((buzzes) => {
      return buzzes.id === reactionId;
    });

    formik.setFieldValue("comment", formik.values.comment + selectedbuzz.emoji);
  };

  const onAttachmentSelected = (file) => {
    formik.setFieldValue("attachment", file);
  };

  const clearAttachment = () => {
    formik.setFieldValue("attachment", null);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      (async () => {
        await formik.submitForm();
      })();
      e.preventDefault();
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
    }
  };

  return (
    <>
      <form
        noValidate
        onKeyDown={handleKeyDown}
        onSubmit={formik.handleSubmit}
        style={classes.root}
      >
        <div style={classes.content}>
          {!formik.values.attachment && (
            <textarea
              autoComplete="off"
              maxLength={500}
              wrap="hard"
              style={classes.inputField}
              type="text"
              className="write-comments"
              id="w-comment"
              name="comment"
              placeholder="Write a message..."
              {...formik.getFieldProps("comment")}
            />
          )}
          {!!formik.values.attachment && (
            <AttachmentPreview
              commentAttachmentPreview={"watercoolerAttachmentPreview"}
              attachment={formik.values.attachment}
              clearAttachment={clearAttachment}
            />
          )}
        </div>
        <div style={classes.allIcons}>
          <AttachmentSelection
            accepted={[".png", ".jpg", ".jpeg"]}
            showRecorderIcon={false}
            onChange={onAttachmentSelected}
            attachmentClass={"mw-25 icon-light"}
          />
          {!formik.values.attachment && (
            <WaterCoolerReaction
              buzzes={buzzes}
              selectedBuzzData={selectedBuzzData}
            />
          )}
          {!formik.isSubmitting && (
            <button
              className={classNames({
                createWaterCoolerCommentButton: true,
                activateWaterCoolerSendButton:
                  !formik.errors.comment && !formik.errors.attachment && true,
              })}
              type="submit"
              disabled={formik.isSubmitting ? true : false}
            >
              <FontAwesomeIcon
                icon={faPaperPlane}
                style={{
                  height: "25px",
                  width: "25px",
                  verticalAlign: "top",
                }}
              />
            </button>
          )}
          {formik.isSubmitting && (
            <ButtonWithProgress
              buttonWithProgressClass="arrowButton"
              isSubmitting={formik.isSubmitting}
              progress={uploadProgress}
              message={""}
              overlay={false}
            />
          )}
        </div>
      </form>
      {formik.errors.comment && (
        <span style={{ color: "#ff5a5a" }}>{formik.errors.comment}</span>
      )}
    </>
  );
};
